import React, { useState } from 'react';
import styles from './EnquiryForm.module.css';
import content from './EnquiryFormContent.json';

const EnquiryForm = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({});
  const [agree, setAgree] = useState(false);

  const handleTabChange = (index) => setActiveTab(index);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e, url) => {
    e.preventDefault();
    if (!agree) {
      alert('Please agree to the terms of service and privacy policy.');
      return;
    }
    console.log('Submitting to:', url, 'Data:', formData);
  };

  const renderFields = (fields) =>
    fields.map((field) => (
      <input
        key={field.name}
        type={field.type}
        name={field.name}
        value={formData[field.name] || ''}
        onChange={handleInputChange}
        className={styles.input}
        placeholder={field.placeholder}
        required={field.placeholder.includes('*')}
      />
    ));

  const renderRadioGroup = (label, name, options) => (
    <div className={styles.radioGroup}>
      <p className={styles.radioLabel}>{label}</p>
      <div className={styles.radioOptions}>
        {options.map((option) => (
          <label key={option} className={styles.radioItem}>
            <input
              type="radio"
              name={name}
              value={option}
              checked={formData[name] === option}
              onChange={handleInputChange}
              required
            />
            {option}
          </label>
        ))}
      </div>
    </div>
  );

  const renderDropdown = (name, config) => (
    <select
      name={name}
      value={formData[name] || ''}
      onChange={handleInputChange}
      className={styles.select}
      required
    >
      <option value="" disabled>{config.label}</option>
      {config.options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  );

  const policyCheck = (
    <div className={styles.policyCheck}>
      <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
      <span>
        {content.policy.label}{' '}
        <a href={content.policy.terms.link} target="_blank" rel="noreferrer">{content.policy.terms.label}</a> &{' '}
        <a href={content.policy.privacy.link} target="_blank" rel="noreferrer">{content.policy.privacy.label}</a>
      </span>
    </div>
  );

  const renderForm = () => {
    if (activeTab === 0) {
      return (
        <form onSubmit={(e) => handleSubmit(e, 'https://solarsquare.in/homes-submit')}>
          {renderFields(content.residential.fields)}
          {renderRadioGroup(
            content.residential.monthlyBillLabel,
            'monthlyBill',
            content.residential.monthlyBillOptions
          )}
          {policyCheck}
          <button className={styles.submitButton}>Submit Details</button>
        </form>
      );
    }

    if (activeTab === 1) {
      return (
        <form onSubmit={(e) => handleSubmit(e, 'https://solarsquare.in/housing-society-submit')}>
          {renderFields(content.housingSociety.fields)}
          {renderDropdown('monthlyBill', content.housingSociety.monthlyBillDropdown)}
          {renderRadioGroup(
            content.housingSociety.designationLabel,
            'designation',
            content.housingSociety.designationOptions
          )}
          {renderDropdown('approvalStatus', content.housingSociety.approvalStatusDropdown)}
          {policyCheck}
          <button className={styles.submitButton}>Submit Details</button>
        </form>
      );
    }

    if (activeTab === 2) {
      return (
        <form onSubmit={(e) => handleSubmit(e, 'https://solarsquare.in/commercial-submit')}>
          {renderFields(content.commercial.fields)}
          {policyCheck}
          <button className={styles.submitButton}>Submit Details</button>
        </form>
      );
    }
  };

  return (
    <div className={styles.formWrapper}>
      <div className={styles.tabs}>
        {content.tabs.map((tab, index) => (
          <button
            key={tab}
            className={`${styles.tab} ${index === activeTab ? styles.activeTab : ''}`}
            onClick={() => handleTabChange(index)}
          >
            {tab}
          </button>
        ))}
      </div>
      {renderForm()}
    </div>
  );
};

export default EnquiryForm;
